import { ICON_SIZES } from "./consts";
import { IconSize } from "./types";

export const isIconSize = (
  value: string | number | undefined
): value is IconSize => (ICON_SIZES as readonly unknown[]).includes(value);
